import { create } from "zustand";

import type {
  ZOpportunityState,
  ZOpportunityViewsState,
} from "../types/zustand";

import { opportunitiesSlice } from "./slice";
import { opportunityViewsSlice } from "./viewSlice";

export const useOpportunitiesStore = create<ZOpportunityState>()((...args) => ({
  ...opportunitiesSlice(...args),
}));

export const useOpportunityViewsStore = create<ZOpportunityViewsState>()(
  (...args) => ({
    ...opportunityViewsSlice(...args),
  }),
);
